module.exports = __webpack_public_path__ + "img/classic_2.0d42f209.jpg";